import * as yup from 'yup'

// This validation is temporary until work is complete on REBUILD-876, to prevent the need for complicated code when rendering
export const postValidator = yup
  .object()
  .shape({
    date: yup.string().required(),
    uri: yup.string().required(),
    titleDecoded: yup.string().required(),
    content: yup.string().required(),
    author: yup
      .object()
      .shape({
        slug: yup.string().required(),
        uri: yup.string().required(),
      })
      .required(),
    postAuthorData: yup
      .object()
      .shape({
        name: yup.string().required(),
      })
      .required(),
  })
  .required()

export const relatedPostValidator = yup
  .object()
  .shape({
    date: yup.string().required(),
    titleDecoded: yup.string().required(),
    author: yup
      .object()
      .shape({
        slug: yup.string().required(),
        uri: yup.string().required(),
      })
      .required(),
    postAuthorData: yup
      .object()
      .shape({
        name: yup.string().required(),
      })
      .required(),
    categories: yup
      .object()
      .shape({
        nodes: yup
          .array()
          .of(
            yup.object().shape({
              name: yup.string().required(),
              slug: yup.string().required(),
              uri: yup.string().required(),
            }),
          )
          .required(),
      })
      .required(),
  })
  .required()

export const categoryPostValidator = yup
  .object()
  .shape({
    date: yup.string().required(),
    titleDecoded: yup.string().required(),
    author: yup
      .object()
      .shape({
        uri: yup.string().required(),
      })
      .required(),
    postAuthorData: yup
      .object()
      .shape({
        name: yup.string().required(),
      })
      .required(),
    postCategories: yup
      .array()
      .of(
        yup.object().shape({
          name: yup.string().required(),
          uri: yup.string().required(),
        }),
      )
      .required(),
  })
  .required()
